import React from "react";
import Signupcom from "../Componets/Signup/Signupcom";
import NavOnlyLogo from "../Componets/layout/Navbar/NavOnlyLogo";

function Signup() {
  return (
    <>
      <NavOnlyLogo />
      <Signupcom />
    </>
  );
}

export default Signup;
